// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE cf-component-icon/src/svgtoreact.sh TO MODIFY

import React from 'react';
import PropTypes from 'prop-types';

var Api = function Api(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return React.createElement(
    'svg',
    {
      className: className,
      'aria-label': label,
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 16 16'
    },
    React.createElement('path', { d: 'M15.124 12.749v-9.5a1.826 1.826 0 0 0-1.781-1.779H2.657A1.826 1.826 0 0 0 .876 3.251v9.5a1.826 1.826 0 0 0 1.781 1.779h10.686a1.826 1.826 0 0 0 1.781-1.781zm-9.26-2.493l-.357-1.187h-1.84l-.357 1.187H2.123L3.9 5.151h1.31l1.781 5.105zM5.27 8.178c-.356-1.068-.534-1.721-.594-1.84s-.059-.3-.119-.356c-.059.3-.3 1.009-.653 2.2H5.27zm5.936-1.425A1.534 1.534 0 0 1 10.671 8a2.21 2.21 0 0 1-1.484.415h-.474V10.2H7.644V5.21h1.6a2.145 2.145 0 0 1 1.425.415 1.378 1.378 0 0 1 .534 1.128zm-2.434.831h.356a1.346 1.346 0 0 0 .772-.177.626.626 0 0 0 .238-.594.725.725 0 0 0-.178-.534.955.955 0 0 0-.654-.179h-.475v1.485h-.06zm3.384 2.671V5.21h1.068v5.105h-1.069z' })
  );
};

Api.propTypes = {
  className: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
};

export default Api;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Api.js
// module id = 1010
// module chunks = 1